import { render } from "./OwlPaginationItem.vue?vue&type=template&id=62627b1d"
import script from "./OwlPaginationItem.vue?vue&type=script&lang=js"
export * from "./OwlPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__